export class UserVisibleError extends Error {}
